export default __webpack_public_path__ + "static/media/mode-3.8c7549cd.svg";